export default function (x, len, padder = " ") {
  const _len = String(x).length
  if (_len < len) {
    return padder.repeat(len - _len) + String(x)
  }
  return String(x)
}
